import { GET_INTERNATIONAL_REGION_REQUEST, GET_INTERNATIONAL_REGION_SUCCESS, GET_INTERNATIONAL_REGION_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalRegion = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_REGION_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalRegion`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_REGION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_REGION_ERROR,
                payload: error.response,
            });
        })
}

